import { render } from "./PlanetView.vue?vue&type=template&id=349eb26c&scoped=true"
import script from "./PlanetView.vue?vue&type=script&lang=js"
export * from "./PlanetView.vue?vue&type=script&lang=js"

import "./PlanetView.vue?vue&type=style&index=0&id=349eb26c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-349eb26c"]])

export default __exports__